(function ($) {
  "use strict";
  window.$ = window.jQuery = $;
  $(function () {
    if ($(document).find('.x-cutlery-box').length) {
      let $cutleryBox = $(document).find('.x-cutlery-box');

      $(document).on('click', function (e) {
        if ($(e.target).parents('.x-cutlery-box').length === 0) {
          $cutleryBox.removeClass('cutlery__box-show');
        } else if ($(e.target).parents('.x-cutlery-menu').length === 0) {
          $cutleryBox.toggleClass('cutlery__box-show');
        }
      })

      $(document).on('click', '.x-cutlery-plus', function (e) {
        e.preventDefault();
        e.stopPropagation();

        window.changeQuantityCutlery($(this).parents('.x-cutlery-quantity'), 'add');
      });

      $(document).on('click', '.x-cutlery-minus', function (e) {
        e.preventDefault();
        e.stopPropagation();

        window.changeQuantityCutlery($(this).parents('.x-cutlery-quantity'), 'delete');
      });

    }
    // Изменение количества товаров
    window.changeQuantityCutlery = function ($addButtonBox, action = "add") {
      let $obInput = $addButtonBox.find('.x-cutlery-input'),
        $obInputText = $(document).find('.x-cutlery-input-text'),
        $obValue = $addButtonBox.find('.x-cutlery-value'),
        $obMinus = $addButtonBox.find('.x-cutlery-minus'),
        $obPlus = $addButtonBox.find('.x-cutlery-plus'),
        $obText = $(document).find('.x-cutlery-text'),
        currentValue = parseInt($obValue.text()),
        max = parseInt($obInput.data('max')),
        newValue = 0;

      if (action === "add") {
        newValue = currentValue + 1;
        $obMinus.prop('disabled', false);
        if (max === newValue) {
          $obPlus.prop('disabled', true);
        }
      } else if (action === 'delete') {
        newValue = currentValue - 1;
        $obPlus.prop('disabled', false);
        if (newValue === 0) {
          $obMinus.prop('disabled', true);
        }
      }

      $obValue.text(newValue);
      $obInput.val(newValue);

      let text = '';
      $(document).find('.x-cutlery-input').each(function () {
        let val = $(this).val(),
          name = $(this).data('name');

        if (val > 0) {
          text += name + ' ' + val + 'шт.; ';
        }
      });
      if (text === "") {
        $obText.text('-');
      } else {
        $obText.text(text);
      }
      $obInputText.val(text);
    }
  })
})(jQuery)


